
/* 获取平台展示信息*/
import {apiRequest} from "@/api/api";
import prjConfig from "@/utils/prjConfig";

/*获取平台展示信息*/
export function getComponyInfo(config) {
	config.data = {portalType: prjConfig.portalType}
    config.method = 'get'
    config.url = '/project/CompanyConfig/getCompanyInfo'
    apiRequest(config)
}

/*获取省份*/
export function getLocation(config) {

}

/*获取城市*/
export function getCity(config) {

}

/*获取区域*/
export function getArea(config) {

}